var _path, _path2, _rect, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaboratoriesLocationOnMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.875 17.9375C35.875 28.9725 24.4719 36.8385 21.3063 38.8099C21.0649 38.9621 20.7854 39.0429 20.5 39.0429C20.2146 39.0429 19.9351 38.9621 19.6937 38.8099C16.529 36.8385 5.125 28.9725 5.125 17.9375C5.125 9.44623 12.0087 2.5625 20.5 2.5625C28.9913 2.5625 35.875 9.44623 35.875 17.9375Z",
    fill: "#3B86FF",
    stroke: "#AACBFF",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.16 18.0399C31.16 20.8671 30.0369 23.5785 28.0377 25.5776C26.0386 27.5768 23.3272 28.6999 20.5 28.6999C17.6728 28.6999 14.9613 27.5768 12.9622 25.5776C10.9631 23.5785 9.83997 20.8671 9.83997 18.0399C9.83997 15.2127 10.9631 12.5013 12.9622 10.5021C14.9613 8.50299 17.6728 7.37988 20.5 7.37988C23.3272 7.37988 26.0386 8.50299 28.0377 10.5021C30.0369 12.5013 31.16 15.2127 31.16 18.0399Z",
    fill: "white",
    stroke: "#AACBFF",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13.6667,
    height: 12.3,
    rx: 3,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 26.3501 25.0337)",
    stroke: "#065EEA",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2001 13.4165L20.2001 19.5665",
    stroke: "#065EEA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2 19.7934C19.5488 19.7934 18.9307 19.7214 18.3748 19.5922C17.7773 19.4533 17.125 19.8912 17.125 20.5265C17.125 20.8582 17.3069 21.1655 17.608 21.2774C17.8292 21.3597 18.0661 21.4317 18.316 21.4921C18.7204 21.5898 19.076 21.8537 19.2519 22.2438L19.3246 22.4052C19.4835 22.7578 19.8248 22.9831 20.2 22.9831C20.5753 22.9831 20.9166 22.7578 21.0755 22.4052L21.1482 22.2438C21.324 21.8537 21.6797 21.5898 22.0841 21.4921C22.334 21.4317 22.5709 21.3597 22.7921 21.2774C23.0932 21.1655 23.275 20.8582 23.275 20.5265C23.275 19.8912 22.6228 19.4533 22.0252 19.5922C21.4693 19.7214 20.8512 19.7934 20.2 19.7934Z",
    stroke: "#065EEA",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 14.7837C21.9859 15.2064 21.6241 15.467 21.225 15.467C20.826 15.467 20.4642 15.2064 20.2 14.7837C19.9359 15.2064 19.5741 15.467 19.175 15.467C18.776 15.467 18.4142 15.2064 18.15 14.7837",
    stroke: "#065EEA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7833 16.8335C17.2236 17.2562 17.8266 17.5168 18.4917 17.5168C19.1568 17.5168 19.7597 17.2562 20.2 16.8335C20.6403 17.2562 21.2432 17.5168 21.9083 17.5168C22.5734 17.5168 23.1764 17.2562 23.6167 16.8335",
    stroke: "#065EEA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaboratoriesLocationOnMap);
export default __webpack_public_path__ + "static/media/LaboratoriesLocationOnMap.c61dad7ae692a0093560c89ab32aec5b.svg";
export { ForwardRef as ReactComponent };